<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="blue">
            <h4 class="title">Feedbacks</h4>
            <p class="category">List of all the Feedbacks</p>
          </md-card-header>
          <md-card-content>
            <feed-back-table table-header-color="green"></feed-back-table>
          </md-card-content>
        </md-card>
      </div>

    </div>
  </div>
</template>

<script>
  import FeedBackTable from '@/components/Tables/FeedBackTable.vue'

  export default{
    components: {
      FeedBackTable
    }
  }
</script>
